export enum ParameterTypeEnum {
  String = 'str',
  Int = 'int',
  Float = 'float',
  Boolean = 'bool',
}
